import type { FaireProductEntity } from "../../entity_types/product";

export const p_yy3k6d5q8f: FaireProductEntity = {
  token: "p_yy3k6d5q8f",
  type: "product",
  name: "Neu Dinner Plate s/2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl: "https://cdn.faire.com/fastly/0576fe8d17ad74f3b23b2383e8dbf10229b7d1c8c41a1c5988649a49b29ec804.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6485ad1d5ef4a2e068f4366f610528bee80c083f7a272a7004e4b7d1357fa8ff.png",
    "https://cdn.faire.com/fastly/d59a8714f51b1a1af8ae45718f7baa64c4636b01544c9b37990de71381dcd508.jpeg",
    "https://cdn.faire.com/fastly/4e10eb6a9759fb8a3dee81190a896ec18f7bf051f4415133c9270890e6c5d0b9.jpeg",
    "https://cdn.faire.com/fastly/a92b937f832eabd19bc8777fcba82e1e67c3d002f53d4f8265cde0ee8a09872f.jpeg",
    "https://cdn.faire.com/fastly/1b1feee213e2361f7b72d3aca5aa2734a10d5f3df1c003358928f30cdf18a90f.jpeg",
    "https://cdn.faire.com/fastly/ab675f3062e2908d0afa5000a7492e3605bdef782c1dcc186c970cc1f97c05f8.jpeg",
    "https://cdn.faire.com/fastly/cc8026a39f7fb22e470056487fd2fd4aea048763f0dfb6ac9947858a8f2d49b9.jpeg",
    "https://cdn.faire.com/fastly/4b0caff53aad55bfaf6bb02d330a6a88be274e49e98c1b46eb23bf566954257b.png",
    "https://cdn.faire.com/fastly/b8666a886bc47d5adef10ea72e5d93ddbbd304a3ff6cf4d5cdd62b99b689ecbb.png",
    "https://cdn.faire.com/fastly/c66cd51f05a26e9b64930505cbc84654287d4a0eddf277f11f1e9fde1a11d7df.png",
    "https://cdn.faire.com/fastly/53bd11cf07b4f592fb47b24997093f137391e56eabcb017c7ea0e58afd4e9fc9.png",
    "https://cdn.faire.com/fastly/0184bf89cf1726aefbf8d7c6cc02f83cffa8cb83f3c1e6dc80ef1e1bd5f07391.png"
  ],
  priceDollars: 23,
  description: "NEU, meaning “new” in German, is a pleasing dinnerware range that pays homage to the Bauhaus ideals where form and detailing is dictated by the function and production of an object. Each piece of Neu is stackable; the punctuated details are designed to maximise storage space.\n\nMaterial: Stoneware\n\nDishwasher and microwave-safe.\n\nSize: Ø 26.5 x 1.7 cm\nSet of 2",
  tags: [],
  msrpDollars: 46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:35.756Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
